<template>
  <div @click="$emit('checked')" class="check-item" :class="{ checked: item.checked, short }">
    <div
      class="check"
      :class="{ 'check--bodyai': isBodyAi }"
      :style="{ backgroundImage: `url('${checkBg}')` }"
    ></div>
    <div class="info" v-html="item.info"></div>
  </div>
</template>

<script>
import checked from '@/assets/MobileScan/checked.svg';
import checkedDmktz from '@/assets/MobileScan/checked_dmktz.svg';
import unchecked from '@/assets/MobileScan/unchecked.svg';
import uncheckedDmktz from '@/assets/MobileScan/unchecked_dmktz.svg';

export default {
  name: 'CheckItem',
  props: {
    item: Object,
    short: Boolean,
  },
  inject: ['isBodyAi'],
  computed: {
    checkBg() {
      const checkedSvg = this.isBodyAi ? checkedDmktz : checked;
      const uncheckedDmktzSvg = this.isBodyAi ? uncheckedDmktz : unchecked;
      return this.item.checked ? checkedSvg : uncheckedDmktzSvg;
    },
  },
};
</script>

<style lang="scss" scoped>
.check-item {
  @apply flex items-center justify-start w-full my-1 py-1;
  min-height: 42px;
  border: 1px solid var(--border-light, #d9d9d9);
  border-radius: 8px;
}
.checked {
  .check {
    // background-image: url('../../../assets/MobileScan/checked.svg');
  }
  .info {
    font-weight: bold;
  }
  background: var(--checklist-bg, #e1e5ff);
}
.short {
  @apply my-0 py-0;
  .check {
    height: 30px;
  }
}
.check {
  @apply px-2;
  // background-image: url('../../../assets/MobileScan/unchecked.svg');
  background-repeat: no-repeat;
  min-width: 50px;
  min-height: 48px;
  background-position: left;
  background-position-x: 20px;

  &--bodyai {
    background-position: center;
  }
}

.info {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--title-color);
  color: var(--checklist-text, #555555);
}
</style>
